import { ApiResult } from '@newview/infrastructure';
export class CustomHelper {
    static NewGuid() {
        let guid = "";
        for (let i = 1; i <= 32; i++) {
            const n = Math.floor(Math.random() * 16.0).toString(16);
            guid += n;
            if ((i == 8) || (i == 12) || (i == 16) || (i == 20))
                guid += "-";
        }
        return guid;
    }
    static ForMatDate(date, fmt) {
        const o = {
            "M+": date.getMonth() + 1, //月份 
            "d+": date.getDate(), //日 
            "h+": date.getHours(), //小时 
            "m+": date.getMinutes(), //分 
            "s+": date.getSeconds(), //秒 
            "q+": Math.floor((date.getMonth() + 3) / 3), //季度 
            "S": date.getMilliseconds() //毫秒 
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }

    static $$(sel) {
        return $(sel);
    }

    //数组去重
    static unique(arr) {
        for (var i = 0; i < arr.length; i++) {
            for (var j = i + 1; j < arr.length; j++) {
                if (arr[i] == arr[j]) {
                    //第一个等同于第二个，splice方法删除第二个
                    arr.splice(j, 1);
                    j--;
                }
            }
        }
        return arr;
    }

    /**
     * 获取Url后面的参数
     * @param paraName 
     */
    static getUrlParam(paraName: string) {
        const url = document.location.toString();
        const arrObj = url.split("?");

        if (arrObj.length > 1) {
            const arrPara = arrObj[1].split("&");
            let arr;

            // tslint:disable-next-line:prefer-for-of
            for (let i = 0; i < arrPara.length; i++) {
                arr = arrPara[i].split("=");

                if (arr != null && arr[0] === paraName) {
                    return arr[1];
                }
            }
            return "";
        } else {
            return "";
        }
    }

    static isNull(obj) {
        if (obj === '' || obj === null || obj === undefined || obj === 'undefined' || obj === 'null') {
          return true
        }
        return false
      }

    static parseApiResult(apiResult: ApiResult) {
        if (this.isNull(apiResult)) return null
        if (apiResult.code === 200 && apiResult.issucess) {
          return apiResult.result
        } else {
          if (!this.isNull(apiResult.msg)) {
            console.error(apiResult.msg);
          } else if (!this.isNull(apiResult.sub_msg)) {            
            console.error(apiResult.sub_msg!);
          }
          return null
        }
      }
}